import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {AnalyticsService} from "../../../../commons/services/analytics-service.service";
import {AccountModel} from "../../../../account/angular/models/account.model";

export class ReportsSupplyFiltersPanelCtrl implements IController {
  // from: any;
  // to: any;
  supplyId: any;
  agentIds: any;
  onFiltersChange: Function;

  /* @ngInject */
  constructor(private $mdPanel, private $state, private splitService, private moment) {
  }

  $onInit() {
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.supply-filters-panel')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          siteId: this.splitService.getSiteId(),
          // from: new Date(this.from),
          // to: new Date(this.to),
          supplyId: this.supplyId,
          agentIds: this.agentIds || [],
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: SupplyFiltersPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/reports/components/panels/reports-supply-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      // from: filterConfig.from,
      // to: filterConfig.to,
      supplyId: filterConfig.supplyId,
      agentIds: filterConfig.agentIds
    })
  }


}

class SupplyFiltersPanelCtrl implements IController {

  private siteId: any;
  private filterConfig: any;

  constructor(private mdPanelRef, private analyticsService: AnalyticsService, private splitService, private moment, private $state) {
    this.siteId = this.mdPanelRef.config.locals.data.siteId;
  }

  $onInit() {
    this.filterConfig = {
      // from: this.mdPanelRef.config.locals.data.from,
      // to: this.mdPanelRef.config.locals.data.to,
      supplyId: this.mdPanelRef.config.locals.data.supplyId,
      agentIds: this.mdPanelRef.config.locals.data.agentIds
    };
  }

  ///////////////////////////////////////////////////////////////////////////////////////

  // onDateChanged() {
  //   if (this.filterConfig.from > this.filterConfig.to) {
  //     this.filterConfig.to = angular.copy(this.filterConfig.from);
  //   }
  // }

  onChangeSupplyId(account: AccountModel) {
    this.filterConfig.supplyId = _.get(account, 'id');
    this.filterConfig.agentIds = [];
  }

  onChangeAgentIds(agentIds) {
    this.filterConfig.agentIds = agentIds;
  }


  onReset() {
    this.filterConfig = {
      // from: this.filterConfig.from,
      // to: this.filterConfig.to,
      supplyId: undefined,
      agentIds: []
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close()
      .then((mdPanelRef) => {
        // const from = this.moment(this.filterConfig.from).startOf('day').valueOf();
        // const to = this.moment(this.filterConfig.to).endOf('day').valueOf();
        const filterConfig = {
          // from: from,
          // to: to,
          supplyId: this.filterConfig.supplyId,
          agentIds: this.filterConfig.agentIds
        };
        mdPanelRef.config.locals.onClose(filterConfig, this.mdPanelRef.config.locals.data.parentScope);
        // this.$state.go('.', {from: from, to: to}, {notify: false, reload: false});
      })
  }

  cancel() {
    this.mdPanelRef.close();
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsSupplyFiltersPanel', {
    bindings: {
      // from: '<',
      // to: '<',
      supplyId: '<',
      agentIds: '<',
      onFiltersChange: '&'
    },
    template: require('./reports-supply-filters-panel.html').default,
    controller: ReportsSupplyFiltersPanelCtrl
  });
